import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function About() {
  const [s, setS] = useState(null); // null = not yet loaded
  useEffect(() => {
    api.get("/site-settings").then(({ data }) => setS(data || {})).catch(() => setS({}));
  }, []);
  const loaded = s !== null;
  const resolve = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
  const src = loaded ? resolve((s && s.niraj_photo_url) || "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB0ZWNoJTIwZWR1Y2F0b3IlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODg5NDczMDh8MA&ixlib=rb-4.1.0&q=85") : "";
  const gallery = loaded && Array.isArray(s.gallery) ? s.gallery : [];
  return (
    <PublicLayout>
      <section className="container-x pt-16 pb-24 grid md:grid-cols-2 gap-14 items-center">
        <div>
          <div className="overline mb-4">About</div>
          <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter text-ink-900">Who is <span className="text-gradient">Niraj Bhaardwaj?</span></h1>
          <p className="mt-6 text-ink-700 leading-relaxed">{(loaded && s.about_long) || "Niraj Bhaardwaj is an AI Expert, Automation Strategist, and Business Mentor helping entrepreneurs, creators, and professionals implement AI into real business systems."}</p>
          <p className="mt-4 text-ink-700 leading-relaxed">His work sits at the intersection of applied AI, systems thinking, and modern business building — focused on outcomes, not hype.</p>
          <div className="mt-8 flex gap-4"><Link to="/courses" className="btn-neon" data-testid="about-explore">Explore courses</Link><Link to="/contact" className="btn-ghost">Get in touch</Link></div>
        </div>
        <div className="rounded-3xl aspect-[4/5] w-full glow-ring overflow-hidden bg-cream-100">
          {loaded && (
            <img src={src} alt="Niraj" className="w-full h-full object-cover transition-opacity duration-500" data-testid="about-niraj-photo" />
          )}
        </div>
      </section>

      <section className="container-x py-16">
        <div className="grid md:grid-cols-3 gap-6">
          {[{h:"Mission",p:"Make AI understandable and useful for every business — not just enterprises."},{h:"Vision",p:"A world where AI multiplies human ambition and shrinks operational drag."},{h:"Method",p:"Practical, systems-first, outcome-driven education. No hype."}].map((b) => (
            <div key={b.h} className="glass rounded-2xl p-8"><div className="overline mb-3">{b.h}</div><p className="text-ink-700 leading-relaxed">{b.p}</p></div>
          ))}
        </div>
      </section>

      {gallery.length > 0 && (
        <section className="container-x pt-8 pb-24" data-testid="about-gallery">
          <div className="overline mb-4">Behind the scenes</div>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-ink-900 max-w-2xl">Moments from the studio, stage, and workshops.</h2>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="about-gallery-grid">
            {gallery.map((g, i) => (
              <figure key={i} className={`relative rounded-2xl overflow-hidden group ${i % 5 === 0 ? "row-span-2 aspect-[3/4]" : "aspect-square"} bg-cream-100`} data-testid={`about-gallery-item-${i}`}>
                <img src={resolve(g.url)} alt={g.caption || `Gallery ${i + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                {g.caption && (
                  <figcaption className="absolute inset-x-0 bottom-0 p-3 text-xs text-white bg-gradient-to-t from-ink-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">{g.caption}</figcaption>
                )}
              </figure>
            ))}
          </div>
        </section>
      )}
    </PublicLayout>
  );
}
